import { render, staticRenderFns } from "./contatti.vue?vue&type=template&id=614da0db"
import script from "./contatti.vue?vue&type=script&lang=js"
export * from "./contatti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports